import ComputerKeyboard from '../computer-keyboard';
import MidiKeyboard from '../midi-keyboard';
import Piano from '../piano';

const defaultKeys = [
  { note: 24, name: 'C' },
  { note: 25, name: 'C# / D♭' },
  { note: 26, name: 'D' },
  { note: 27, name: 'D# / E♭' },
  { note: 28, name: 'E' },
  { note: 29, name: 'F' },
  { note: 30, name: 'F# / G♭' },
  { note: 31, name: 'G' },
  { note: 32, name: 'G# / A♭' },
  { note: 33, name: 'A' },
  { note: 34, name: 'A# / B♭' },
  { note: 35, name: 'B' },

  { note: 36, name: 'C' },
  { note: 37, name: 'C# / D♭' },
  { note: 38, name: 'D' },
  { note: 39, name: 'D# / E♭' },
  { note: 40, name: 'E' },
  { note: 41, name: 'F' },
  { note: 42, name: 'F# / G♭' },
  { note: 43, name: 'G' },
  { note: 44, name: 'G# / A♭' },
  { note: 45, name: 'A' },
  { note: 46, name: 'A# / B♭' },
  { note: 47, name: 'B' },

  { note: 48, name: 'C' },
  { note: 49, name: 'C# / D♭' },
  { note: 50, name: 'D' },
  { note: 51, name: 'D# / E♭' },
  { note: 52, name: 'E' },
  { note: 53, name: 'F' },
  { note: 54, name: 'F# / G♭' },
  { note: 55, name: 'G' },
  { note: 56, name: 'G# / A♭' },
  { note: 57, name: 'A' },
  { note: 58, name: 'A# / B♭' },
  { note: 59, name: 'B' },

  { note: 60, name: 'C' },
  { note: 61, name: 'C# / D♭' },
  { note: 62, name: 'D' },
  { note: 63, name: 'D# / E♭' },
  { note: 64, name: 'E' },
  { note: 65, name: 'F' },
  { note: 66, name: 'F# / G♭' },
  { note: 67, name: 'G' },
  { note: 68, name: 'G# / A♭' },
  { note: 69, name: 'A' },
  { note: 70, name: 'A# / B♭' },
  { note: 71, name: 'B' },

  { note: 72, name: 'C' },
  { note: 73, name: 'C# / D♭' },
  { note: 74, name: 'D' },
  { note: 75, name: 'D# / E♭' },
  { note: 76, name: 'E' },
  { note: 77, name: 'F' },
  { note: 78, name: 'F# / G♭' },
  { note: 79, name: 'G' },
  { note: 80, name: 'G# / A♭' },
  { note: 81, name: 'A' },
  { note: 82, name: 'A# / B♭' },
  { note: 83, name: 'B' },

  { note: 84, name: 'C' },
  { note: 85, name: 'C# / D♭' },
  { note: 86, name: 'D' },
  { note: 87, name: 'D# / E♭' },
  { note: 88, name: 'E' },
  { note: 89, name: 'F' },
  { note: 90, name: 'F# / G♭' },
  { note: 91, name: 'G' },
  { note: 92, name: 'G# / A♭' },
  { note: 93, name: 'A' },
  { note: 94, name: 'A# / B♭' },
  { note: 95, name: 'B' },

  { note: 96, name: 'C' },
  { note: 97, name: 'C# / D♭' },
  { note: 98, name: 'D' },
  { note: 99, name: 'D# / E♭' },
  { note: 100, name: 'E' },
  { note: 101, name: 'F' },
  { note: 102, name: 'F# / G♭' },
  { note: 103, name: 'G' },
  { note: 104, name: 'G# / A♭' },
  { note: 105, name: 'A' },
  { note: 106, name: 'A# / B♭' },
  { note: 107, name: 'B' }
];

const keys = defaultKeys.map(key => {
  const sharp = key.name.indexOf('#') !== -1;
  const additionalClass = sharp ? ' sharp' : '';

  key.class = `key${additionalClass}`;

  return key;
});

export default {
  methods: {
    mouseUp (event) {
      Piano.state.mouseDown = false;
      this.stopNote(event.target.dataset.note);
    },

    mouseDown (event) {
      if (Piano.state.mouseDown) {
        return;
      }

      Piano.state.mouseDown = true;
      this.startNote(event.target.dataset.note);
    },

    mouseOver (event) {
      if (Piano.state.mouseDown) {
        this.startNote(event.target.dataset.note);
      }
    },

    mouseOut (event) {
      if (!Piano.state.mouseDown) {
        return;
      }

      if (!event.relatedTarget.classList.contains('key')) {
        Piano.state.mouseDown = false;
      }

      this.stopNote(event.target.dataset.note);
    },

    startNote (midiNumber) {
      Piano.startNote(midiNumber);
    },

    stopNote (midiNumber) {
      Piano.stopNote(midiNumber);
    },

    onNoteStart (options) {
      const { midiNumber, chorded } = options;
      const key = this.$el.querySelector('[data-note="' + midiNumber + '"]');

      key.classList.add('playing');

      if (chorded) {
        key.classList.add('chorded');
      }
    },

    onNoteStop (options) {
      const { midiNumber } = options;
      const key = this.$el.querySelector('[data-note="' + midiNumber + '"]');

      key.classList.remove('playing');
    },

    disable () {
      this.$el.querySelector('.keys').classList.add('loading');
    },

    enable () {
      document.querySelector('.keys').classList.remove('loading');
    }
  },

  mounted () {
    const keyHolder = this.$el;

    if (keyHolder.scrollWidth > keyHolder.clientWidth) {
      keyHolder.scrollLeft = (keyHolder.scrollWidth - keyHolder.clientWidth) / 2;
      // A console.debug('keyHolder.scrollLeft', (keyHolder.scrollWidth - keyHolder.clientWidth) / 2);
    }

    ComputerKeyboard.init();
    MidiKeyboard.init();

    document.addEventListener('noteStart', event => {
      this.onNoteStart(event.detail);
    }, { passive: true });

    document.addEventListener('noteStop', event => {
      this.onNoteStop(event.detail);
    }, { passive: true });
  },

  data () {
    return { keys };
  }
};



// WEBPACK FOOTER //
// ./src/components/keyboard/keyboard.js